import React, { useState } from "react";
import { CanvasWrapper, prepareForCanvas } from "./IdeaCanvasModal";
import DesignCanvasList from "../ai_home/DesignCanvasList";
import { Button, Grid } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { MessageCodeView } from "../ai_home/ChatBox";
import { useBotEndpoint } from "../_actions/bot";
import { useSingleItem } from "../_actions/app/items";

function IdeaCanvasBox({
    entry_id,
    data,
    open,
    setOpen,
    loading,
    me,
    onUpdate = () => {},
}) {
    const [open_cust, setOpenCust] = useState(true);
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isMobile = !screens.sm;
    const [localData, setLocalData] = useState(data);

    const { data: fullEntryData } = useSingleItem(
        "qdb_calendar_entries",
        `/${entry_id}?fields=*,platforms.*`,
        !!entry_id
    );

    React.useEffect(() => {
        setLocalData(data);
    }, [data]);

    const { mutateAsync: generateFestivalData, isLoading: processingFestival } =
        useBotEndpoint("/gen/generate_festival_data", (res) => {
            setLocalData((prev) => ({
                ...prev,
                status: "generated",
                generated_data: res?.data || res,
            }));
        });

    const processNow = async (d) => {
        if (d?.status === "processed" || d?.stauts === "processed") {
            if (d?.data_type === "festival") {
                await generateFestivalData(d.idea_processed);
            }
        }
    };

    return (
        <>
            <CanvasWrapper
                open={open}
                setOpen={setOpen}
                title="Canvas"
                actions={[
                    <Button
                        size={isMobile ? "large" : "middle"}
                        block={isMobile}
                    >
                        Download
                    </Button>,
                ]}
                width={isMobile ? "100%" : open_cust ? "80vw" : "56vw"}
            >
                {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
                {/* <MessageCodeView
                    data={{
                        language: "json",
                        code: data,
                        message: "Generated Idea"
                    }}
                /> */}

                {localData.status !== "generated" && (
                    <Button
                        onClick={() => processNow(localData)}
                        loading={processingFestival}
                        size={isMobile ? "large" : "middle"}
                        block={isMobile}
                    >
                        Process Now
                    </Button>
                )}
                {(loading || processingFestival) && (
                    <p>Generating content....</p>
                )}
                {/* <MessageCodeView  default_show={false} data={{  language: "json",  message: "data", code: data }} /> */}
                {localData.status === "idea" && (
                    <MessageCodeView
                        default_show={false}
                        data={{
                            language: "json",
                            message: "data",
                            code: localData,
                        }}
                    />
                )}
                {localData.status === "generated" && (
                    <DesignCanvasList
                        key={localData?.generated_data?.canvas}
                        data={prepareForCanvas(
                            localData?.generated_data?.canvas
                        )}
                        me={me}
                        isMobile={isMobile}
                        entry_id={entry_id}
                        platforms={fullEntryData?.platforms || []}
                        entry={fullEntryData}
                        closeBtn={
                            <Button
                                color="default"
                                // type="text"
                                icon={<CloseOutlined />}
                                onClick={() => setOpen(false)}
                            />
                        }
                        close_left={true}
                        open_cust={open_cust}
                        setOpenCust={setOpenCust}
                        history_id={
                            localData?.generated_data?.canvas?.history_id
                        }
                        onUpdate={onUpdate}
                        close={() => setOpen(false)}
                    />
                )}
                {/* </div>
            </div> */}
            </CanvasWrapper>

            {/* </OneCanvasWrapper> */}
        </>
    );
}

export default IdeaCanvasBox;
